// Bouton primitif — encapsule les regles du DESIGN-GUIDE (section 4).
// Variantes : primary | secondary | ghost | danger | icon
// Consomme les tokens (grad-primary, bg-card, text-ink...) -> s'adapte au theme.

const VARIANTS = {
  primary: 'text-white font-semibold rounded-xl py-3.5 grad-primary hover:opacity-90',
  secondary: 'text-white text-sm font-semibold rounded-xl py-3 grad-accent hover:opacity-90',
  ghost: 'text-sm font-semibold rounded-xl px-5 py-3 border bg-card border-card-border text-ink hover:opacity-80',
  danger:
    'text-sm font-semibold rounded-xl py-3 border border-red-500/15 text-[#f85149] bg-[rgba(248,81,73,0.04)] hover:bg-[rgba(248,81,73,0.08)]',
  icon: 'w-8 h-8 rounded-xl flex items-center justify-center text-sm bg-card border border-card-border text-ink',
}

export default function Button({
  variant = 'primary',
  fullWidth = false,
  className = '',
  children,
  ...props
}) {
  const base = 'transition active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none'
  const width = fullWidth ? 'w-full' : ''
  const variantCls = VARIANTS[variant] || VARIANTS.primary
  return (
    <button className={`${base} ${variantCls} ${width} ${className}`.trim()} {...props}>
      {children}
    </button>
  )
}
